import Cart from "../components/cart";

const Carts = ( selector ) => {
    const elements = document.querySelectorAll( selector );
    if( typeof( elements ) !== 'undefined' && elements.length > 0 ){
        elements.forEach( el => {
            let cart = new Cart( el  );
        })
    }
}

export default Carts
